import styles from './NewsLettersPage.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import IconAndName from '../../components/IconAndName/IconAndName';
import { FaUserPlus } from 'react-icons/fa';
import { LuClock3 } from 'react-icons/lu';
import CopyRight from '../../components/CopyRight/CopyRight';
import { FiSend } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import SelectedStudents from '../../modals/SelectedStudents/SelectedStudents';

import NewsLetterCard from '../../components/NewsLetterCard/NewsLetterCard';

const newsletterData = [
  { id: 1, name: 'Weekly Update' },
  { id: 2, name: 'Holiday Plans' },
  { id: 3, name: 'Monthly Digest' },
  { id: 4, name: 'Upcoming Events' },
  { id: 5, name: 'Student Highlights' },
  { id: 6, name: 'Sports Recap' },
  { id: 7, name: 'Science Fair' },
  { id: 8, name: 'Parent Newsletter' },
  { id: 9, name: 'Summer Camp Info' },
  { id: 10, name: 'End of Year Wrap' },
];

const data = [
  {
    _id: '1',
    name: 'John Jacob',
    status: 'Sent',
    updatedOn: '21 May 2025',
    sentTo: '2 Students',
    createdBy: 'John Jacob',
    actionOptions: ['Edit', 'Delete'],
    students: [{ name: 'John Jacob' }, { name: 'Jane Doe' }],
  },
  {
    _id: '2',
    name: 'Emily Rose',
    status: 'Sent',
    updatedOn: '22 May 2025',
    sentTo: '2 Students',
    createdBy: 'Emily Rose',
    actionOptions: ['Edit', 'Delete'],
    students: [{ name: 'Emily Rose' }, { name: 'Sam Lee' }],
  },
];

function NewsLettersPage() {
  const modalType = useSelector((state) => state.modal.modalType);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const handleCreate = () => {
    dispatch(openModal('createNewsLetter'));
  };

  const handleOptionsClick = (option, itemId) => {
    if (option === 'Edit') {
      dispatch(openModal('createNewsLetter')); // or "editNewsletter" if it's a different modal
    } else if (option === 'Delete') {
      dispatch(openModal('delete')); // or "deleteNewsletter" if you have that modal
    }
  };

  const handleAddProgram = () => {
    dispatch(openModal('createNewsLetter'));
  };
  const handlecheckAvailability = () => {
    dispatch(openModal('checkAvailability'));
  };

  // at top
  const handleShowStudents = (students) => {
    setSelectedStudents(students);
    dispatch(openModal({type : 'selectedStudents' , data: students}));
  };

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        title: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.6rem',
              cursor: 'pointer',
            }}
            onClick={() => dispatch(openModal('newsLetter'))}
          >
            {/* Icon with green dot */}
            <div className={styles.iconWithDot}>
              <FiSend size={20} color="#6A6CFF" />
              <span className={styles.greenDot} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span
                style={{
                  fontWeight: 500,
                  fontSize: '15px',
                  color: '#1A237E',
                }}
              >
                {item.name}
              </span>
              <span
                style={{
                  fontSize: '13px',
                  color: '#888',
                  marginTop: '2px',
                }}
              >
                Sent | Updated on : {item.updatedOn}
              </span>
            </div>
          </div>
        ),

        createdBy: <span style={{ color: '#888' }}>{item.createdBy}</span>,
        sentTo: (
          <span
            style={{ color: 'var(--Primary_Color)', cursor: 'pointer' }}
            onClick={() => handleShowStudents(item.students)}
          >
            {item.sentTo}
          </span>
        ),

        action: (
          <Action
            key={item._id}
            options={item.actionOptions}
            onSelect={(opt) => {
              if (opt === 'Edit') dispatch(openModal('createNewsLetter'));
              else if (opt === 'Delete') dispatch(openModal('createActivity'));
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Title', accessor: 'title' },
    { title: 'Created By', accessor: 'createdBy' },
    { title: 'Newsletter Sent To', accessor: 'sentTo' },
    { title: 'Action', accessor: 'action' },
  ];

  return (
    <div className={styles.copyright}>
      <div className={styles.programcontainer}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <h4
              style={{
                color: 'var(--Primary_Color)',
                fontWeight: '400',
              }}
            >
              Recent Designs
            </h4>
            <IconAndName
              icon={<FaUserPlus />}
              title="Create Newsletter"
              bgColor="Primary_Color"
              onClick={handleAddProgram}
            />
          </div>

          <div className={styles.resultandcount}>
            <NewsLetterCard isEmpty onClick={handleCreate} />
            {newsletterData.map((item) => (
              <NewsLetterCard
                key={item.id}
                id={item.id}
                name={item.name}
                onOptionsClick={handleOptionsClick}
              />
            ))}
          </div>

          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search by title"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.dropdown}>
                <Dropdown label="Staff" options={['Room1', 'Room2']} />
                <Dropdown
                  label="News Letters"
                  options={['Label 1', 'Label 2']}
                />
              </div>
            </div>

            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      {modalType === 'selectedStudents' && (
        <SelectedStudents
          students={selectedStudents}
          onClose={() => dispatch(closeModal())}
        />
      )}

      <CopyRight />
    </div>
  );
}

export default NewsLettersPage;
